<template>
  <div class="contact-bar pt-34 pb-34">
    <div class="contact-bar__inner container grid">
      <div
        class="contact-bar__row flex justify-center"
        v-for="(item, i) in content[1]"
        :key="i"
      >
        <div class="contact-bar__row--inner flex column">
          <span class="f-16 bold">{{ _.get(item, "title") }}</span>
          <span class="f-16 medium">{{ _.get(item, "teaser") }}</span>
        </div>
      </div>
      <div class="contact-bar__row flex justify-center">
        <div class="contact-bar__row--inner flex column">
          <span class="f-16 bold mb-5">{{
            $fn.tr("contact bar socials title")
          }}</span>
          <div class="contact-bar__row--socials flex">
            <a
              :href="item.url"
              v-html="_.get(item, 'svg')"
              v-for="(item, i) in content[0]"
              :key="i"
            ></a>
          </div>
        </div>
      </div>
      <div class="contact-bar__row flex">
        <img :src="content[2]" alt="QR Code Citymall" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    content() {
      const c = this.$store.state.main.indx.widgets.contact_bar;
      const s = [],
        o = [],
        f = [];
      let img;

      for (const [key, value] of Object.entries(c)) {
        console.log(value);
        if (!Array.isArray(value) && value.svg) {
          s.push(value);
        }
        if (Array.isArray(value)) {
          img = value[0].url;
        }
        if (!Array.isArray(value) && !value.svg) {
          o.push(value);
        }
      }
      f.push(s, o, img);
      return f;
    },
  },

  mounted() {
    console.log(this.content);
  },
};
</script>

<style lang="scss">
.contact-bar {
  &__inner {
    grid-template-columns: 230px 303px 355px 293px 185px;
    align-items: center;
    img {
      width: 94px;
      height: 94px;
      object-fit: cover;
    }
  }
  &__row {
    &:not(:last-child) {
      height: 60px;
      padding-top: 7px;
      padding-bottom: 7px;
    }

    &:not(:first-child) {
      border-right: rgba(26, 26, 26, 0.1) 1px solid;
      border-left: rgba(26, 26, 26, 0.1) 1px solid;
    }
    &:last-child {
      justify-content: flex-end;
      border-right: transparent 1px solid;
      border-left: transparent 1px solid;
    }
    &:nth-child(4) {
      a {
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
  }
  @media (max-width: 1550px) {
    &__inner {
      grid-template-columns: 233px 283px 253px 322px 1fr;
    }
  }
  @media (max-width: 1440px) {
    &__inner {
      grid-template-columns: 195px 233px 283px 222px 1fr;
    }
    &__row {
      &:first-child {
        justify-content: flex-start;
      }
      &:last-child {
        justify-content: flex-end;
      }
    }
  }
  @media (max-width: 1125px) {
    &__inner {
      grid-template-columns: 176px 196px 247px 185px minmax(114px, 1fr);
    }
    &__row {
      &:first-child {
        justify-content: flex-start;
      }
      &:last-child {
        justify-content: flex-end;
      }
    }
  }
  @media (max-width: 1125px) {
    &__inner {
      grid-template-columns: 176px 196px 247px 185px minmax(114px, 1fr);
    }
  }
  @media (max-width: 1023px) {
    padding-top: 51px;
    padding-bottom: 58px;
    &__inner {
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      grid-row-gap: 38px;
    }
    &__row {
      &:nth-child(4) {
        justify-content: flex-start;
        border-left: none;
      }
      &:nth-child(3) {
        border-left: none;
        border-right: none;
        padding-left: 34px;
      }
      &:nth-child(2) {
        padding-left: 34px;
        justify-content: flex-start;
      }
      &:last-child {
        justify-content: flex-start;
        padding-left: 34px;
      }
    }
  }
  @media (max-width: 767px) {
    padding-bottom: 44px;
    &__inner {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 60px 60px 94px;
      grid-template-areas:
        "phone email"
        "address socials"
        "qr qr";
      grid-row-gap: 28px;
    }
    &__row {
      &:nth-child(5) {
        grid-area: qr;
        padding-left: 0;
        justify-content: center;
        margin-top: 10px;
      }
      &:nth-child(4) {
        justify-content: flex-start;
        padding-left: 43px;
        border-left: none;
        border-right: none;
        grid-area: socials;
      }
      &:nth-child(3) {
        border-left: none;
        border-right: rgba(26, 26, 26, 0.1) 1px solid;
        padding-left: 0;
        justify-content: flex-start;
        grid-area: address;
      }
      &:nth-child(2) {
        padding-left: 43px;
        justify-content: flex-start;
        border-right: none;
        grid-area: email;
      }
      &:nth-child(1) {
        grid-area: phone;
      }
    }
  }
  @media (max-width: 413px) {
    &__inner {
      grid-template-columns: 1fr;
      grid-template-rows: 60px 60px 60px 94px;
      grid-template-areas:
        "phone"
        "email"
        "address"
        "socials"
        "qr";
      grid-row-gap: 28px;
    }
    &__row {
      span{
        text-align: center;
      }
      &:nth-child(5) {
        grid-area: qr;
        justify-content: center;
        margin-top: 0px;
        padding-left: 0;
      }
      &:nth-child(4) {
        justify-content: center;

        padding-left: 0;

        grid-area: socials;
      }
      &:nth-child(3) {
        border-left: none;
        border-right: none;
        padding-left: 0;
        justify-content: center;

        grid-area: address;
      }
      &:nth-child(2) {
        padding-left: 43px;
        justify-content: center;
        border-right: none;
        border-left: none;
        grid-area: email;
        padding-left: 0;
      }
      &:nth-child(1) {
        grid-area: phone;
        justify-content: center;
        padding-left: 0;
      }
    }
  }
}
</style>
